import React from 'react';
import { Event } from '../../types/events.types';
import ErrorBoundary from '../../../components/react/error_boundary/error_boundary';
import format from 'date-fns/format';
import { DATE_FORMAT, DATE_FORMAT_NO_YEAR } from '../../../event_details/constants/event_details.constants';

interface Props {
  event: Event;
}

const DateRange: React.FC<Props> = ({ event }) => {
  const { starts_at, ends_at, multiYearEvent, multiDayEvent } = event;

  const renderStartsAtDate = (
    <span data-testid='starts-at-date'>
      {format(
        new Date(starts_at),
        multiYearEvent
          ? DATE_FORMAT
          : multiDayEvent
            ? DATE_FORMAT_NO_YEAR
            : DATE_FORMAT
      )}
    </span>
  );

  const renderMultiDaysEvent: JSX.Element = (
    <>
      {renderStartsAtDate}
      {' - '}
      <span data-testid='ends-at-date'>
        {format(new Date(ends_at), DATE_FORMAT)}
      </span>
    </>
  );

  return (
    <ErrorBoundary>
      {event.multiDayEvent
        ? renderMultiDaysEvent
        : renderStartsAtDate
      }
    </ErrorBoundary>
  );
};

export default DateRange;
